// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as OrderHistoryViewHelper from "../../components/driver-records/utils/OrderHistoryViewHelper.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getView(orders, workspace_dispatch) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: orders,
              children: (function (orders) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: OrderHistoryViewHelper.getColumnSchema(workspace_dispatch),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(orders.orders, undefined, 5),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getView ,
  
}
/* react Not a pure module */
